"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const typography_1 = require("@andes/typography");
const react_1 = require("react");
const GoogleSVG_1 = __importDefault(require("../../assets/svg/GoogleSVG"));
const executeNative_1 = require("../../helpers/executeNative");
const ButtonRequestProps_1 = require("../../../types/ButtonRequestProps");
const urls_1 = require("../../../utils/urls");
const GoogleButtonMobile = ({ text = '', navigation, onSuccess, onError, closeCallback, clickListener, }) => {
    const onSuccessRef = (0, react_1.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, react_1.useRef)(onError);
    onErrorRef.current = onError;
    const handleClick = async () => {
        try {
            const schemasByPlatform = {
                [ButtonRequestProps_1.Platforms.ML]: ButtonRequestProps_1.AppUrlSchemes.ML,
                [ButtonRequestProps_1.Platforms.MP]: ButtonRequestProps_1.AppUrlSchemes.MP,
            };
            const schema = schemasByPlatform[navigation.platform_id];
            const baseDeepLink = `${schema}//social-account`;
            const params = {
                site_id: navigation.site_id,
                source: navigation.source,
                social_flow: 'google',
                platform_id: navigation.platform_id,
                client_type: navigation.client_type,
                close_callback: closeCallback,
            };
            const deepLink = (0, urls_1.deepLinkBuilder)(baseDeepLink, params);
            clickListener?.();
            await (0, executeNative_1.executeNative)(deepLink, {});
            onSuccessRef.current?.();
        }
        catch (error) {
            onErrorRef.current?.(error);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("button", { className: "gsi-material-button", onClick: handleClick, children: [(0, jsx_runtime_1.jsx)("div", { className: "gsi-material-button-state" }), (0, jsx_runtime_1.jsxs)("div", { className: "gsi-material-button-content-wrapper", children: [(0, jsx_runtime_1.jsx)("div", { className: "gsi-material-button-icon", children: (0, jsx_runtime_1.jsx)(GoogleSVG_1.default, {}) }), (0, jsx_runtime_1.jsx)(typography_1.Typography, { color: "secondary", weight: "semibold", children: text })] })] }));
};
exports.default = GoogleButtonMobile;
